import { useEffect } from "react";
import { useRouteError } from "react-router";

/**
 * Último recurso: se uma tela quebra fora de qualquer área com tela de erro
 * própria (o backoffice tem a dele), quem usa vê esta mensagem em vez do erro
 * técnico do React Router. O erro de verdade vai para o console.
 */
export const AppRouteError = () => {
  const error = useRouteError();

  useEffect(() => {
    console.error("[AppRouteError]", error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-white p-8 text-center">
      <h1 className="text-xl font-semibold text-black">
        Algo deu errado por aqui.
      </h1>
      <p className="max-w-md text-sm text-gray-600">
        Não foi possível mostrar esta página agora. Tente de novo; se continuar,
        fale com o nosso time.
      </p>
      <div className="flex flex-wrap justify-center gap-2">
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="bg-primary cursor-pointer rounded-lg px-4 py-2 text-white shadow transition hover:opacity-90"
        >
          Tentar de novo
        </button>
        <a
          href="/"
          className="cursor-pointer rounded-lg border border-gray-300 px-4 py-2 text-black transition hover:bg-gray-50"
        >
          Voltar ao início
        </a>
      </div>
    </div>
  );
};
